(function () {
  'use strict';

  var sections = document.querySelectorAll('[data-shaya-deferred-recommendations="true"]');

  if (!sections.length) {
    return;
  }

  function hideSection(section) {
    section.hidden = true;
    section.setAttribute('aria-busy', 'false');
  }

  function initializeThemeSection(section) {
    section.setAttribute('data-section-type', 'product-recommendations');
    section.removeAttribute('data-shaya-deferred-recommendations');
    section.setAttribute('aria-busy', 'false');

    if (section.parentElement) {
      section.parentElement.dispatchEvent(new CustomEvent('shopify:section:load', {
        bubbles: true,
        detail: { sectionId: section.getAttribute('data-section-id') }
      }));
    }
  }

  function loadRecommendations(section) {
    if (section.dataset.shayaRecommendationsLoaded === 'true') {
      return;
    }

    section.dataset.shayaRecommendationsLoaded = 'true';

    var productId = section.getAttribute('data-shaya-product-id');
    var count = section.getAttribute('data-shaya-recommendations-count') || '4';
    var endpoint = window.routes && window.routes.productRecommendationsUrl;

    if (!productId || !endpoint) {
      hideSection(section);
      return;
    }

    var url = endpoint + '?section_id=' + encodeURIComponent(section.getAttribute('data-section-id')) +
      '&product_id=' + encodeURIComponent(productId) +
      '&limit=' + encodeURIComponent(count);

    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Recommendations request failed');
        }

        return response.text();
      })
      .then(function (html) {
        var container = document.createElement('div');
        container.innerHTML = html;

        var source = container.querySelector('.ProductRecommendations');
        var target = section.querySelector('.ProductRecommendations');

        if (!source || !target || !source.querySelector('[data-flickity-config]')) {
          hideSection(section);
          return;
        }

        target.innerHTML = source.innerHTML;
        initializeThemeSection(section);
      })
      .catch(function () {
        hideSection(section);
      });
  }

  sections.forEach(function (section) {
    if (window.Shopify && window.Shopify.designMode) {
      loadRecommendations(section);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      loadRecommendations(section);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        observer.disconnect();
        loadRecommendations(section);
      });
    }, { rootMargin: '800px 0px' });

    observer.observe(section);
  });
}());
